<template>
  <div class="searchBox" :style="`width:${htmlName == '融合教研' || htmlName == '资源中心' ? '80%' : htmlName == '校长论坛' ? '50%' : ''};`">
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" label-width="58px">
      <el-row :style="`display:${htmlName == '融合教研' || htmlName == '校长论坛' || htmlName == '资源中心' ? 'flex' : ''};justify-content:${htmlName == '融合教研' || htmlName == '校长论坛' || htmlName == '资源中心' ? 'flex-end' : ''}`">
        <el-col v-if="htmlName == '基地学校'" :span="7">
          <el-form-item label="城市：" prop="city">
            <el-select v-model="queryParams.city" size="small" style="width: 1.6rem;" @change="cityChange">
              <el-option v-for="dict in marketOption" :key="dict.id" :label="dict.name" :value="dict.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="县（市区）：" prop="area" label-width="100px">
            <el-select v-model="queryParams.area" size="small" style="width: 1.6rem;" @change="areachange">
              <el-option v-for="dict in areaOption" :key="dict.id" :label="dict.name" :value="dict.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-else-if="htmlName == '群组'" :span="12">
          <!-- <el-form-item label="省份：" prop="province">
            <el-select v-model="queryParams.province" size="small" style="width: 1.6rem;" @change="provinceChange">
              <el-option v-for="dict in provinceOption" :key="dict.id" :label="dict.name" :value="dict.id" />
            </el-select>
          </el-form-item> -->
          <el-form-item v-if="areaLevel == 1" label="城市：" prop="city">
            <el-select v-model="queryParams.city" size="small" style="width: 1.6rem;" @change="cityChange">
              <el-option v-for="dict in marketOption" :key="dict.id" :label="dict.name" :value="dict.id" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="areaLevel == 1 || areaLevel == 2" label="县（市区）：" prop="area" label-width="100px">
            <el-select v-model="queryParams.area" size="small" style="width: 1.6rem;" @change="areachange">
              <el-option v-for="dict in areaOption" :key="dict.id" :label="dict.name" :value="dict.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-else-if="htmlName == '计划'" :span="22">
          <el-form-item label="省份：" prop="province">
            <el-select v-model="queryParams.province" size="small" style="width: 1.6rem;" @change="provinceChange">
              <el-option v-for="dict in provinceOption" :key="dict.id" :label="dict.name" :value="dict.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="城市：" prop="city">
            <el-select v-model="queryParams.city" size="small" style="width: 1.6rem;" @change="cityChange">
              <el-option v-for="dict in marketOption" :key="dict.id" :label="dict.name" :value="dict.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="县（市区）：" prop="area" label-width="100px">
            <el-select v-model="queryParams.area" size="small" style="width: 1.6rem;" @change="areachange">
              <el-option v-for="dict in areaOption" :key="dict.id" :label="dict.name" :value="dict.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="学校：" prop="schoolId" label-width="80px">
            <el-select v-model="queryParams.schoolId" size="small" style="width: 1.6rem;" @change="schoolchange">
              <el-option v-for="dict in schoolList" :key="dict.sid" :label="dict.sname" :value="dict.sid" />
            </el-select>
          </el-form-item>
          <el-form-item label="时间：" prop="createTime">
            <el-date-picker v-model="queryParams.createTime" value-format="yyyy-MM-dd" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 2.6rem;" @change="changetime"/>
          </el-form-item>
        </el-col>
        <el-col v-else-if="htmlName == '活动'" :span="12">
          <el-form-item label="省份：" prop="province">
            <el-select v-model="queryParams.province" size="small" style="width: 1.6rem;" @change="provinceChange">
              <el-option v-for="dict in provinceOption" :key="dict.id" :label="dict.name" :value="dict.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="城市：" prop="city">
            <el-select v-model="queryParams.city" size="small" style="width: 1.6rem;" @change="cityChange">
              <el-option v-for="dict in marketOption" :key="dict.id" :label="dict.name" :value="dict.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="县（市区）：" prop="area" label-width="100px">
            <el-select v-model="queryParams.area" size="small" style="width: 1.6rem;" @change="areachange">
              <el-option v-for="dict in areaOption" :key="dict.id" :label="dict.name" :value="dict.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="状态：" prop="readType">
            <el-select v-model="queryParams.readType" size="small" style="width: 1.8rem;" @change="readtypechange">
              <el-option v-for="dict in readtypeOption" :key="dict.id" :label="dict.name" :value="dict.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="时间：" prop="createTime">
            <el-date-picker v-model="queryParams.createTime" value-format="yyyy-MM-dd" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 2.6rem;"  @change="changetime"/>
          </el-form-item>
        </el-col>
        <el-col v-else-if="htmlName == '专家团队'" :span="4">
          <!-- <el-form-item label="分类：" prop="level">
            <el-select v-model="queryParams.level" size="small" style="width: 1.8rem;" @change="levelchange">
              <el-option v-for="dict in levelOption" :key="dict.id" :label="dict.name" :value="dict.id" />
            </el-select>
          </el-form-item> -->
          <el-form-item label="学科：" prop="subjectId">
            <el-select v-model="queryParams.subjectId" size="small" style="width: 1.8rem;" @change="subjectchange">
              <el-option v-for="dict in subjectOption" :key="dict.subjectId" :label="dict.subjectName"
                :value="dict.subjectId" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-else-if="htmlName == '名师工作室'" :span="14">
          <el-form-item label="分类" prop="typeId">
            <el-select v-model="queryParams.typeId" size="small" style="width: 1.8rem;" @change="typeidchange">
              <el-option v-for="dict in levelOption" :key="dict.msTypeId" :label="dict.msTypeName"
                :value="dict.msTypeId" />
            </el-select>
          </el-form-item>
          <el-form-item label="学段" prop="clazzId">
            <el-select v-model="queryParams.clazzId" size="small" style="width: 1.8rem;" @change="clazzIdchange">
              <el-option v-for="dict in yearOption" :key="dict.msStageId" :label="dict.msStageName"
                :value="dict.msStageId" />
            </el-select>
          </el-form-item>
          <el-form-item label="学科" prop="subjectId">
            <el-select v-model="queryParams.subjectId" size="small" style="width: 1.8rem;" @change="subjectchange">
              <el-option v-for="dict in subjectOption" :key="dict.subjectId" :label="dict.subjectName"
                :value="dict.subjectId" />
            </el-select>
          </el-form-item>
          <el-form-item label="课题组" prop="extend3">
            <el-select clearable v-model="queryParams.extend3" size="small" style="width: 1.8rem;" @change="ktZchange">
              <el-option label="是" value="0" />
              <el-option label="否" value="1" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-else-if="htmlName == '名校长工作室'" :span="14">
          
        </el-col>
        <el-col v-else-if="htmlName == '零碳工作坊'" :span="14">
          <el-form-item label="分类" prop="typeId">
            <el-select v-model="queryParams.typeId" size="small" style="width: 1.8rem;" @change="typeidchange">
              <el-option v-for="dict in levelOption" :key="dict.msTypeId" :label="dict.msTypeName"
                :value="dict.msTypeId" />
            </el-select>
          </el-form-item>
          <el-form-item label="学段" prop="clazzId">
            <el-select v-model="queryParams.clazzId" size="small" style="width: 1.8rem;" @change="clazzIdchange">
              <el-option v-for="dict in yearOption" :key="dict.msStageId" :label="dict.msStageName"
                :value="dict.msStageId" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-else :span="htmlName == '命题服务' || htmlName == '融合教研' || htmlName == '校长论坛' || htmlName == '资源中心' ?18:14">
          <el-form-item v-if="htmlName == '命题服务'" label="类型：" prop="typeId">
            <el-select v-model="queryParams.bigType" size="small" style="width: 1.6rem;" @change="bigtypechange">
              <el-option label="试卷" value="1" />
              <el-option label="视频" value="2" />
            </el-select>
          </el-form-item>
          <el-form-item label="分类：" prop="typeId">
            <el-select v-model="queryParams.typeId" size="small" style="width: 1.6rem;" @change="typeChange">
              <el-option v-for="dict in typeOption" :key="dict.typeId" :label="dict.typeName" :value="dict.typeId" />
            </el-select>
          </el-form-item>
          <el-form-item label="学科：" prop="subjectId" v-if="htmlName != '校长论坛'">
            <el-select v-model="queryParams.subjectId" size="small" style="width: 1.6rem;" @change="subjectchange">
              <el-option v-for="dict in subjectOption" :key="dict.subjectId" :label="dict.subjectName"
                :value="dict.subjectId" />
            </el-select>
          </el-form-item>
          <el-form-item label="年级：" prop="clazzId" v-if="htmlName != '校长论坛'">
            <el-select v-model="queryParams.clazzId" size="small" style="width: 1.6rem;" @change="clazzIdchange">
              <el-option v-for="dict in yearOption" :key="dict.clazzId" :label="dict.clazzName" :value="dict.clazzId" />
            </el-select>
          </el-form-item>
          <el-form-item label="时间：" prop="createTime">
            <!-- <el-date-picker v-model="queryParams.startTime" type="date" placeholder="开始日期" style="width: 165px;" value-format="yyyy-MM-dd" clearable>
            </el-date-picker>
            <el-date-picker v-model="queryParams.endTime" type="date" placeholder="结束日期" style="width: 165px;" value-format="yyyy-MM-dd" clearable>
            </el-date-picker> -->
            <el-date-picker v-model="queryParams.createTime" value-format="yyyy-MM-dd" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 2.6rem;"  @change="changetime"/>
          </el-form-item>
        </el-col>
        <el-form-item v-if="htmlName != '活动' && htmlName != '计划' && htmlName != '名师工作室'" label="" prop="keyWord">
          <el-input v-model="queryParams.keyWord" :placeholder="'输入'+htmlName+'的关键词'" clearable style="width: 2.2rem;" @input="keywordchange" @clear="clearword"/>
        </el-form-item>
        <el-form-item v-if="htmlName == '名师工作室'" label="" prop="keyWord">
          <el-input v-model="queryParams.keyWord" :placeholder="'输入课题组编号/名称'" clearable style="width: 2.2rem;" @input="keywordchange" @clear="clearword"/>
        </el-form-item>
        <el-form-item :style="`margin-right:${htmlName == '融合教研' || htmlName == '校长论坛' || htmlName == '资源中心' ? '' : '.2rem'} `">
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleSearch">搜索</el-button>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  import { gettypeList, getclazzList, getsubjectList } from "@/api/video";
  import { getProvinceList, getCityList, getmanageSchool } from "@/api/school";
  import { getTypeTList, getClassList } from "@/api/teacher";
  export default {
    props: {
      htmlName: {
        type: String,
        default: ''
      },
      queryParams: {
        type: Object,
        default: () => {
          return {}
        }
      },
    },
    data() {
      return {
        typeOption: [],
        subjectOption: [],
        yearOption: [],
        levelOption: [],
        provinceOption: [],
        marketOption: [],
        schoolList: [],
        areaOption: [{ name: '全部', id: null }],
        readtypeOption: [
          { name: '全部', id: 0 },
          { name: '未开始', id: 1 },
          { name: '进行中', id: 2 },
          { name: '已结束', id: 3 },
        ],
        areaLevel: 1,     // 管理中心的搜索权限sessionStorage.getItem("areaLevel")
      };
    },
    created() {
      if (this.htmlName == '基地学校' || this.htmlName == '学校' || this.htmlName == '活动') {
        getProvinceList().then(response => {
          // response.data.unshift({name: '全部',id: null})
          // this.provinceOption = response.data;
          this.provinceOption = [{ name: '山西省', id: 220 }];
        });
        getCityList({ pid: 220 }).then(response => {
          if (response.code == 200) {
            response.data.unshift({ name: '全部', id: null })
            this.marketOption = response.data;
          }
        });
        if (this.queryParams.city) {
          getCityList({ pid: this.queryParams.city }).then(response => {
            if (response.code == 200) {
              response.data.unshift({ name: '全部', id: null })
              this.areaOption = response.data;
            }
          });
        }
      } else if (this.htmlName == '计划') {
        getProvinceList().then(response => {
          // response.data.unshift({name: '全部',id: null})
          // this.provinceOption = response.data;
          this.provinceOption = [{ name: '山西省', id: 220 }];
        });
        getCityList({ pid: 220 }).then(response => {
          if (response.code == 200) {
            response.data.unshift({ name: '全部', id: null })
            this.marketOption = response.data;
          }
        });
        if (this.queryParams.city) {
          getCityList({ pid: this.queryParams.city }).then(response => {
            if (response.code == 200) {
              response.data.unshift({ name: '全部', id: null })
              this.areaOption = response.data;
            }
          });
        }
        getmanageSchool().then(res => {
          if (res.code == 200) {
            this.schoolList = res.data
          }
        })
      } else if (this.htmlName == '名师工作室') {
        getTypeTList().then(response => {
          if (response.code == 200) {
            response.data.unshift({ msTypeName: '全部', msTypeId: null })
            this.levelOption = response.data;
          }
        });
        getClassList().then(response => {
          if (response.code == 200) {
            response.data.unshift({ msStageName: '全部', msStageId: null })
            this.yearOption = response.data;
          }
        });
        getsubjectList().then(response => {
          if (response.code == 200) {
            response.data.unshift({ subjectName: '全部', subjectId: null })
            this.subjectOption = response.data;
          }
        });
      } else if (this.htmlName == '零碳工作坊') {
        getTypeTList().then(response => {
          if (response.code == 200) {
            // // 过滤掉市级工作室
            // let filteredData = response.data.filter(item => item.msTypeName !== '市级工作室');
            //  // 在最前面插入“全部”选项
            // filteredData.unshift({ msTypeName: '全部', msTypeId: null });
            // this.levelOption = filteredData;
            response.data.unshift({ msTypeName: '全部', msTypeId: null })
            this.levelOption = response.data;
          }
        });
        getClassList().then(response => {
          if (response.code == 200) {
            response.data.unshift({ msStageName: '全部', msStageId: null })
            this.yearOption = response.data;
          }
        });
      } else {
        gettypeList().then(response => {
          if (response.code == 200) {
            response.data.unshift({ typeName: '全部', typeId: null })
            this.typeOption = response.data;
          }
        });
        getsubjectList().then(response => {
          if (response.code == 200) {
            response.data.unshift({ subjectName: '全部', subjectId: null })
            this.subjectOption = response.data;
          }
        });
        getclazzList().then(response => {
          if (response.code == 200) {
            response.data.unshift({ clazzName: '全部', clazzId: null })
            this.yearOption = response.data;
          }
        });
      }
    },
    methods: {
      typeChange(e) {
        getsubjectList({ typeId: e }).then(response => {
          response.data.unshift({ subjectName: '全部', subjectId: null })
          this.subjectOption = response.data;
        });
        getclazzList({ typeId: e }).then(response => {
          response.data.unshift({ clazzName: '全部', clazzId: null })
          this.yearOption = response.data;
        });
        if(e){
          this.queryParams.typeId = e
          this.$emit('handleQuery', this.queryParams);
        }else{
          this.queryParams.typeId = null
          this.$emit('handleQuery', this.queryParams);
        }
      },
      // 下拉省的选择
      provinceChange(e) {
        this.queryParams.city = null;
        this.queryParams.area = null;
        if (e) {
          getCityList({ pid: e }).then(response => {
            response.data.unshift({ name: '全部', id: null })
            this.marketOption = response.data;
          });
          this.queryParams.province = e
          this.$emit('handleQuery', this.queryParams);
        } else {
          this.marketOption = [{ name: '全部', id: null }];
          this.queryParams.province = null
          this.$emit('handleQuery', this.queryParams);
        }
      },
      // 下拉市的选择
      cityChange(e) {
        this.queryParams.area = null;
        if (e) {
          getCityList({ pid: e }).then(response => {
            response.data.unshift({ name: '全部', id: null })
            this.areaOption = response.data;
          });
          this.queryParams.city = e
          this.$emit('handleQuery', this.queryParams);
        } else {
          this.areaOption = [{ name: '全部', id: null }];
          this.queryParams.city = null
          this.$emit('handleQuery', this.queryParams);
        }
      },
      ktZchange(e){
        if(e){
          this.queryParams.extend3 = e
          this.$emit('handleQuery', this.queryParams);
        }else{
          this.queryParams.extend3 = null
          this.$emit('handleQuery', this.queryParams);
        }
      },
      // 下拉县的选择
      areachange(e){
        if(e){
          this.queryParams.area = e
          this.$emit('handleQuery', this.queryParams);
        }else{
          this.queryParams.area = null
          this.$emit('handleQuery', this.queryParams);
        }
      },
      // 下拉学校的选择
      schoolchange(e){
        if(e){
          this.queryParams.schoolId = e
          this.$emit('handleQuery', this.queryParams);
        }else{
          this.queryParams.schoolId = null
          this.$emit('handleQuery', this.queryParams);
        }
      },
      // 时间选择
      changetime(e){
        if(e && e.length != 0){
          this.queryParams.startTime = e[0]
          this.queryParams.endTime = e[1]
          this.$emit('handleQuery', this.queryParams);
        }else{
          this.queryParams.startTime = null
          this.queryParams.endTime = null
          this.$emit('handleQuery', this.queryParams);
        }
      },
      // 状态选择
      readtypechange(e){
        if(e){
          this.queryParams.readType = e
          this.$emit('handleQuery', this.queryParams);
        }else{
          this.queryParams.readType = null
          this.$emit('handleQuery', this.queryParams);
        }
      },
      // 分类选择
      levelchange(e){
        if(e){
          this.queryParams.level = e
          this.$emit('handleQuery', this.queryParams);
        }else{
          this.queryParams.level = null
          this.$emit('handleQuery', this.queryParams);
        }
      },
      // 学科选择
      subjectchange(e){
        if(e){
          this.queryParams.subjectId = e
          this.$emit('handleQuery', this.queryParams);
        }else{
          this.queryParams.subjectId = null
          this.$emit('handleQuery', this.queryParams);
        }
      },
      // 名师工作室分类
      typeidchange(e){
        if(e){
          this.queryParams.typeId = e
          this.$emit('handleQuery', this.queryParams);
        }else{
          this.queryParams.typeId = null
          this.$emit('handleQuery', this.queryParams);
        }
      },
      // 年级选择
      clazzIdchange(e){
        this.$set(this.queryParams,'subjectId', null);
        getsubjectList({typeId:e}).then(response => {
          if (response.code == 200) {
            response.data.unshift({ subjectName: '全部', subjectId: null })
            this.subjectOption = response.data;
          }
        });
        if(e){
          this.queryParams.clazzId = e
          this.$emit('handleQuery', this.queryParams);
        }else{
          this.queryParams.clazzId = null
          this.$emit('handleQuery', this.queryParams);
        }
      },
      // 命题服务类型
      bigtypechange(e){
        if(e){
          this.queryParams.bigType = e
          this.$emit('handleQuery', this.queryParams);
        }else{
          this.queryParams.bigType = null
          this.$emit('handleQuery', this.queryParams);
        }
      },
      // 关键词搜索
      keywordchange(e){
        if(e){
          this.queryParams.keyWord = e
          this.$emit('handleQuery', this.queryParams);
        }else{
          this.queryParams.keyWord = null
          this.$emit('handleQuery', this.queryParams);
        }
      },
      clearword(){
          this.queryParams.keyWord = null
          this.$emit('handleQuery', this.queryParams);
      },
      handleSearch() {
        this.queryParams.pageNum = 1;
        if(!this.queryParams.startTime && this.queryParams.endTime){
          this.$message.error('请选择开始时间');
          return
        }
        if(this.queryParams.startTime && !this.queryParams.endTime){
          this.$message.error('请选择结束时间');
          return
        }
        if(this.queryParams.startTime && this.queryParams.endTime){
          if(this.queryParams.startTime > this.queryParams.endTime){
            this.$message.error('开始时间不能大于结束时间');
            return
          }
        }
        this.$emit('handleQuery', this.queryParams);
      },
    }
  };
</script>

<style>
  .searchBox {
    padding-top: .16rem;
  }

  .searchBox>>>.el-form-item__label {
    text-align: left;
  }
</style>


// WEBPACK FOOTER //
// src/components/Search.vue